import React from 'react';

// nodejs library to set properties for components
import PropTypes from 'prop-types';

// nodejs library that concatenates classes
import classNames from 'classnames';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

// core components
import CoreInput from '../CoreInput/CoreInput';
import styles from '../../assets/jss/material-kit-react/components/customInputStyle';

const useStyles = makeStyles(styles);

export default function CustomInput(props) {
  const classes = useStyles();

  const {
    formControlProps,
    labelText,
    id,
    // labelProps,
    inputProps,
    // error,
    // white,
    // inputRootCustomClasses,
    // success,
    // fullWidth,
  } = props;

  var formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = classNames(formControlProps.className, classes.formControl);
  } else {
    formControlClasses = classes.formControl;
  }

  return (
    <FormControl {...formControlProps} className={formControlClasses}>
      <InputLabel shrink htmlFor="bootstrap-input">
        {labelText}
      </InputLabel>
      <CoreInput {...inputProps} id={id} />
    </FormControl>
  );
}

CustomInput.propTypes = {
  labelText: PropTypes.node,
  // labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  // error: PropTypes.bool,
  success: PropTypes.bool,
  // white: PropTypes.bool,
  // fullWidth: PropTypes.bool,
};
